import { useEffect } from 'react';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { usePromotePageData } from 'src/app/pages/promote/pageContext';
import { pullBandit } from 'src/app/shared/api/bandits';

export function useButtonBanditPull(): void {
	const utilityContext = useUtilityContext();
	const {
		data: { petition },
	} = usePromotePageData();

	useEffect(() => {
		if (petition.bandits?.contextualPromotionButtons?.selectedVariant) {
			void pullBandit(
				{
					experimentName: petition.bandits.contextualPromotionButtons.experimentName,
					variantName: petition.bandits.contextualPromotionButtons.selectedVariant.variantName,
				},
				utilityContext,
				{ silent: true },
			);
		}

		// only do the pull once per page load, so leave the dependency array empty
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
}
